<template>
  <div>
    <div
      v-if="sheets.length > 0"
      style="width: 80%"
      class="px-3 pt-5 mx-auto"
    >
      <v-text-field
        v-model="keyword"
        prepend-inner-icon="mdi-magnify"
        clearable
        dense
        rounded
        outlined
      ></v-text-field>
    </div>
    <v-list style="margin-top: -28px;">
      <v-list-item
        v-for="(sheet) in searchedSheets"
        :key="'sheet' + sheet.no"
        :to="'/workspace/' + sheet.no"
      >
        <v-list-item-content>
          <v-list-item-title v-text="sheet.name"></v-list-item-title>
        </v-list-item-content>

        <v-list-item-icon
          @click.prevent="copySheet(sheet.no)"
        >
          <v-btn icon>
              <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import common from '@/mixins/common'
import db from '@/mixins/db'

export default {
  mixins: [common, db],
  props: ['sheets'],
  data () {
    return {
      keyword: localStorage.getItem('keyword') || ''
    }
  },
  computed: {
    searchedSheets () {
      const searchedSheets = []
      for (const i in this.sheets) {
        const sheet = this.sheets[i]
        if (!this.keyword || sheet.name.toLowerCase().indexOf(this.keyword.toLowerCase()) !== -1) {
          searchedSheets.push(sheet)
        }
      }
      return searchedSheets
    }
  },
  methods: {
    // -------- DB利用 --------
    copySheet (no) {
      this.openDb(() => {
        const store = this.startTransaction('readwrite')

        // 元のsheetデータを取得
        const reqCurrent = store.get(no)
        reqCurrent.onsuccess = (e) => {
          const sheet = reqCurrent.result

          // コピーするsheetデータの調整
          sheet.ver = this.ver
          sheet.time = this.getTime()
          sheet.name = sheet.name + ' -COPY'
          sheet.copy = true // コピーで作成した印
          delete sheet.no // key の no は削除

          // コピーのsheetデータを登録
          const reqCopy = store.put(sheet)
          reqCopy.onsuccess = (e) => {
            this.name = ''
            this.$emit('set-sheets')
          }
          reqCopy.onerror = (e) => {
            alert('[copySheet openDb reqCopy Error] Sorry, application error.')
            return false
          }
        }
        reqCurrent.onerror = (e) => {
          alert('[copySheet openDb reqCurrent Error] Sorry, application error.')
          return false
        }
      })
    }
    // -------- /DB利用 --------
  },
  updated () {
    localStorage.setItem('keyword', this.keyword || '')
  }
}
</script>
